import { useSubscription } from '../../../hooks/useSubscription';
import { SubscriptionStatus } from '../../../types/subscriptions';
import { PauseSubscriptionModal } from './PauseSubscriptionModal';
import { ResumeSubscriptionModal } from './ResumeSubscriptionModal';
import { jsx as _jsx } from "react/jsx-runtime";
export function PauseModal({
  objectId,
  actions
}) {
  const {
    status
  } = useSubscription();
  return status === SubscriptionStatus.Paused ? /*#__PURE__*/_jsx(ResumeSubscriptionModal, {
    objectId: objectId,
    actions: actions
  }) : /*#__PURE__*/_jsx(PauseSubscriptionModal, {
    objectId: objectId,
    actions: actions
  });
}